import {
  GridModalFormProps,
  UseFormReturnType,
  Validator,
  globalMessageHandler,
  loadMultipleOptions,
  useForm,
} from "common";
import { useParams } from "common/components/Form/ParamsContext";
import { getProgramService } from "features/programs/programApi";
import { getReviewPartnerService } from "features/review-partners/reviewPartnerApi";
import I18n from "i18n";
import { Params } from "react-router-dom";
import {
  ProgramReviewUrlItem,
  ProgramReviewUrlOptions,
  getProgramReviewUrlService,
} from "./programReviewUrlApi";

export interface UseProgramReviewUrlFormProps extends GridModalFormProps {}

type RouteParams = {
  program_review_url_id?: string;
};

export interface UseProgramReviewUrlFormReturnType
  extends UseFormReturnType<ProgramReviewUrlItem, ProgramReviewUrlOptions> {
  params?: Readonly<
    Params<"program_review_url_id" | "program_id" | "review_partner_id">
  >;
}

export default function useProgramReviewUrlForm({
  id,
  afterSave,
  defaultValues,
}: UseProgramReviewUrlFormProps): UseProgramReviewUrlFormReturnType {
  const params = useParams<
    "program_review_url_id" | "program_id" | "review_partner_id"
  >();
  const scope = {
    programs: params.program_id,
    "review-partners": params.review_partner_id,
  };
  const service = getProgramReviewUrlService(scope);

  const form = useForm<ProgramReviewUrlItem, ProgramReviewUrlOptions>({
    id: params.program_review_url_id || id,
    ignoreNavigateAfterCreate: true,
    translationCategory: "ProgramReviewUrl",
    rules: {
      review_partner_id: params.review_partner_id
        ? Validator.rule.optional()
        : Validator.rule.any().required(),
      program_id: params.program_id
        ? Validator.rule.optional()
        : Validator.rule.any().required(),
      lang: Validator.rule.any().required(),
      url: Validator.rule.string().uri().required(),
    },
    afterSave,
    defaultValues,
    onValidationFailed: () => {
      globalMessageHandler.snack({
        severity: "error",
        message: I18n.t("App.formHasErrors"),
      });
    },
    ...service,
    loadOptions: loadMultipleOptions({
      review_partner_id: () =>
        getReviewPartnerService(undefined).loadAutocomplete(),
      program_id: () => getProgramService(undefined).loadAutocomplete(),
    }),
  });

  return { ...form, params };
}
